import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, notFound } from "@tanstack/react-router"

import {
  getBusinessEntityCurrenciesQueryOptions,
  getBusinessEntityInvoicePeriodsQueryOptions,
  getExtendedBusinessEntityQueryOptions,
} from "~/modules/business-entities/business-entities.queries"
import { BusinessEntityFinancial } from "~/modules/business-entities/components/business-entity-financial"
import { getAvailableGlobalCurrenciesQueryOptions } from "~/modules/system-config/system-config.queries"

export const Route = createFileRoute(
  "/_protected-layout/_os-layout/business-entities/$businessEntitySlug/financial",
)({
  component: RouteComponent,
  loader: async ({ context, params }) => {
    const extendedBusinessEntity = await context.queryClient.ensureQueryData(
      getExtendedBusinessEntityQueryOptions({
        businessEntitySlug: params.businessEntitySlug,
      }),
    )

    if (!extendedBusinessEntity) {
      throw notFound()
    }

    // Prefetch financial data in parallel
    await Promise.all([
      context.queryClient.ensureQueryData(
        getAvailableGlobalCurrenciesQueryOptions(["active"]),
      ),
      context.queryClient.ensureQueryData(
        getBusinessEntityCurrenciesQueryOptions({
          businessEntityId: extendedBusinessEntity.id,
        }),
      ),
      context.queryClient.ensureQueryData(
        getBusinessEntityInvoicePeriodsQueryOptions({
          businessEntityId: extendedBusinessEntity.id,
        }),
      ),
    ])
  },
})

function RouteComponent() {
  const { businessEntitySlug } = Route.useParams()

  const { data: businessEntity } = useSuspenseQuery(
    getExtendedBusinessEntityQueryOptions({
      businessEntitySlug,
    }),
  )

  if (!businessEntity) {
    throw notFound()
  }

  return <BusinessEntityFinancial businessEntityId={businessEntity.id} />
}
